export {
  copyToClipboard,
  getFileExtension,
  mapToLabelValue,
  openInNewTab,
  scrollToElementById,
} from '@avanta/shared/utils/common';

export function normalize(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export const scrollToTop = (): void => {
  window.scrollTo({ top: 0, behavior: 'instant' });
};
